import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductStatusService } from '../../../services/product-status.service';

@Component({
  selector: 'app-view-product-statuses',
  templateUrl: './view-product-statuses.component.html',
  styleUrls: ['./view-product-statuses.component.css'],
  providers:[ProductStatusService]
})
export class ViewProductStatusesComponent implements OnInit {
  id: number = undefined;
  private sub: any;
  productStatus: any = {
    laptops: false,
    consoles: false,
    products: false,
    mobiles: false
  };
  constructor(private productStatusService:ProductStatusService, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
      if (params['id'] !== undefined){
        this.id = params['id'];
        this.getProductStatus();
      }
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getProductStatus(){
    this.productStatusService.get(this.id).subscribe((productStatus) => {
      this.productStatus = productStatus;
    });
  }
  

  saveProductStatus(){
    this.parseProductsType();
    if (this.productStatus.id == undefined){
      this.productStatusService.create(this.returnProductStatusProperties(this.productStatus))
      .subscribe((productStatus) => {
        this.productStatusService.get(productStatus.id).subscribe((productStatus) => {
          this.productStatus = productStatus;
          this.router.navigate(['/configuration/productstatuses']);
        });
      });
    }else{
      this.productStatusService.update(this.returnProductStatusProperties(this.productStatus))
      .subscribe((productStatus) => {
        this.productStatus = productStatus;
      });
    }
  }

  returnProductStatusProperties(productStatus){
    var properties = {
      name: productStatus.name,
      product_types: productStatus.product_types
    }
    if (productStatus.id){
      properties['id'] = productStatus.id;
    }
    return properties;
  }

  parseProductsType(){
    this.productStatus.product_types = "";
    if(this.productStatus.mobiles === true){
      this.productStatus.product_types += "1,";
    }
    if(this.productStatus.consoles === true){
      this.productStatus.product_types += "2,";
    }
    if(this.productStatus.products === true){
      this.productStatus.product_types += "3,";
    }
    if(this.productStatus.laptops === true){
      this.productStatus.product_types += "4,";
    }
    this.productStatus.product_types = this.productStatus.product_types.substring(0,this.productStatus.product_types.length - 1);
  }

}



// WEBPACK FOOTER //
// ./src/app/configuration/components/product-statuses/view-product-statuses/view-product-statuses.component.ts